// HolidayContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import moment from 'moment-jalaali';

interface IHolidayProviderProps {
  holidays: string[] | null;
  selectedYear: string;
  handleChangeSelectedYear: (year: string) => void;
}

const HolidayContext = createContext<IHolidayProviderProps | undefined>(
  undefined
);

export const HolidayProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [holidays, setHolidays] = useState<string[] | null>(null);
  const [selectedYear, setSelectedYear] = useState<string>(
    moment().format('jYYYY')
  );

  const API = `https://api.persian-calendar.ir/api/v1/calendar/${selectedYear}/holidays`;

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const res = await fetch(API);
        const data = await res.json();
        const holidayList = data.data.map((item: any) => item.date);
        setHolidays(holidayList);
      } catch (error) {
        console.error('Failed to fetch holidays:', error);
        setHolidays([]);
      }
    };

    fetchHolidays();
  }, [selectedYear]);

  const handleChangeSelectedYear = (year: string) => {
    setSelectedYear(year);
  };

  return (
    <HolidayContext.Provider
      value={{ holidays, selectedYear, handleChangeSelectedYear }}
    >
      {children}
    </HolidayContext.Provider>
  );
};

export const useHolidays = () => {
  const context = useContext(HolidayContext);
  if (!context) {
    throw new Error('useHolidays must be used within a HolidayProvider');
  }
  return context;
};
